import { Box, Typography, styled } from '@mui/material';
import { ProductAddonCardProps } from '../../../models/Collection';
import { CollectionProductImage } from 'components/collections/CollectionProductItem/CollectionProductImage';
import { CollectionProductPrice } from 'components/collections/CollectionProductItem/CollectionProductNetPrice';
import { useNavigate } from 'react-router-dom';

const StyledImage = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    img: {
        maxWidth: '100%',
    },
}));

const StyledWrapper = styled(Box)(() => ({
    border: '1px solid #f5f5f5',
    borderRadius: '5px',
    height: '100%',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '20px',
    cursor: 'pointer',
    background: '#FFF',
    transition: 'all 150ms ease-in-out',
    ':hover': {
        filter: 'drop-shadow(5px 5px 10px #00000022)',
    },
}));

const StyledCardContent = styled(Box)(() => ({
    display: 'flex',
    gap: '10px',
    alignItems: 'start',
    flexWrap: 'wrap',
    ' > *': {
        flex: '1',
    },
}));

const StyledContainer = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
}));

export const ProductAddonCard = (props: ProductAddonCardProps) => {
    const { product } = props;

    const navigate = useNavigate();

    const productHandle = '/products/' + product.product_handle;

    const redirectOnClick = () => {
        navigate(productHandle);
    };

    return (
        <StyledWrapper onClick={redirectOnClick}>
            <StyledImage>
                <CollectionProductImage imageSrc={product.images[0]} />
            </StyledImage>
            <StyledContainer>
                <Box
                    sx={{
                        justifyContent: 'center',
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 'bold',
                        }}
                    >
                        {product.title}
                    </Typography>
                </Box>
                <StyledCardContent>
                    <CollectionProductPrice price={product.price} />
                </StyledCardContent>
            </StyledContainer>
        </StyledWrapper>
    );
};
